import { jwtDecode } from "jwt-decode";
import User from "../types/user";

export const AUTH_STATUS = Object.freeze({
  LOADING: "loading",
  AUTHENTICATED: "authenticated",
  UNAUTHENTICATED: "unauthenticated",
});

export const USER_ROLES = Object.freeze({
  ADMIN: "Admin",
  AUDITOR: "Auditor",
  CUSTOMER: "Customer",
  LOGOPORTAL: "LogoPortalAccess",
  LOGOPORTALSUBUSER: "LogoPortalSubUser"
});

export const getUserRole = (user: User) => {
  return {
    isAdmin: user?.roles?.includes(USER_ROLES.ADMIN),
    isAuditor: user?.roles?.includes(USER_ROLES.AUDITOR),
    isCustomer: user?.roles?.includes(USER_ROLES.CUSTOMER),
    isLogoPortalUser : user?.roles?.includes(USER_ROLES.LOGOPORTAL),
    isLogoPortalSubUser : user?.roles?.includes(USER_ROLES.LOGOPORTALSUBUSER)
  };
};

export const getUserFromToken = (token: string) => {
  try {
    return jwtDecode(token);
  } catch (error) {
    console.error("Invalid token", error);
    return null;
  }
};

export const isTokenValid = () => {
  const token = localStorage.getItem("access_token");
  if (!token) {
    return false;
  }

  const tokenExpiry = localStorage.getItem("access_token_expiry");

  try {
    const decodedToken = JSON.parse(atob(token.split(".")[1]));

    const currentTimeInSeconds = Math.floor(Date.now() / 1000);
    if (
      (decodedToken.exp && decodedToken.exp < currentTimeInSeconds) ||
      (tokenExpiry &&
        !isNaN(Number(tokenExpiry)) &&
        Number(tokenExpiry) < Date.now())
    ) {
      return false;
    }
  } catch (e) {
    console.error("Error decoding the token", e);
    return false;
  }

  return true;
};
